import { call, put } from 'redux-saga/effects';
import { ApiError } from 'store/api/types';
import { CheckContactsRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { CheckContactsResponse, checkContacts } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { checkContactsFailure, checkContactsSuccess } from '../actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* checkContactsSaga(action: CheckContactsRequestAction) {
  try {
    let err: ApiError | null;
    const { connectionId } = action.payload;

    const response: CheckContactsResponse = yield call(
      checkContacts,
      connectionId
    );
    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.contacts-were-checked'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    const lastViesCheckDate = response.data.lastViesCheckDate;
    const contacts = response.data.contacts;

    yield put(checkContactsSuccess(lastViesCheckDate, contacts, connectionId));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(checkContactsFailure());
  }
}
